import React, { ChangeEvent, Dispatch } from "react";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import ApproveIcon from "@material-ui/icons/Check";
import DenyIcon from "@material-ui/icons/Clear";

import {
  changeEntryStatus,
  StallApplicationCheckboxType,
  TAction
} from "../helper";
import useStyles from "./styles";

interface IProps extends CheckboxProps {
  type: StallApplicationCheckboxType;
  checked: boolean;
  dispatch?: Dispatch<TAction>;
  entryId?: string;
}

const StableEntryStateCheckbox = (props: IProps) => {
  const { type, checked, dispatch, onChange, entryId, ...restProps } = props;
  const classes = useStyles();

  const isApproveType = type === StallApplicationCheckboxType.APPROVE;

  const handleChangeStatus = (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    if (onChange) {
      onChange(event, checked);
      return;
    }

    let newStatus: racehorse360.StableEntryStatus;

    if (!checked) {
      newStatus = racehorse360.StableEntryStatus.STABLE_ENTRY_STATUS_AWAITING;
    } else if (isApproveType) {
      newStatus = racehorse360.StableEntryStatus.STABLE_ENTRY_STATUS_APPROVED;
    } else if (!isApproveType) {
      newStatus = racehorse360.StableEntryStatus.STABLE_ENTRY_STATUS_DENIED;
    }

    dispatch(changeEntryStatus(entryId, newStatus));
  };

  const renderCheckboxIcon = (checked: boolean = false) => {
    return isApproveType ? (
      <ApproveIcon className={clsx(classes.checkboxIcon, { checked })} />
    ) : (
      <DenyIcon className={clsx(classes.checkboxIcon, { checked })} />
    );
  };

  return (
    <Checkbox
      {...restProps}
      icon={renderCheckboxIcon()}
      checkedIcon={renderCheckboxIcon(true)}
      classes={{
        root: classes.checkboxRoot,
        checked: clsx({
          [classes.approved]: isApproveType,
          [classes.denied]: !isApproveType
        })
      }}
      disableRipple={true}
      checked={checked}
      onChange={handleChangeStatus}
    />
  );
};

export default React.memo(StableEntryStateCheckbox);
